import React, { useState, createContext, useContext, useMemo, ReactElement, ReactNode } from 'react';
import DragOverlayConsumer from './DragOverlayConsumer';

interface DragOverlayContextType {
  draggedElement: ReactElement | null;
  showDraggedElement: (element: ReactElement | null) => void;
  hideDraggedElement: () => void;
}

const initialState: DragOverlayContextType = {
  draggedElement: null,
  showDraggedElement: () => {},
  hideDraggedElement: () => {},
};

const DragOverlayContext = createContext(initialState);
export const useDragOverlayContext = (): DragOverlayContextType => useContext(DragOverlayContext);

interface DragOverlayProviderProps {
  children: ReactNode;
}

const DragOverlayProvider = ({ children }: DragOverlayProviderProps): React.ReactElement => {
  const [draggedElement, setDraggedElement] = useState<ReactElement | null>(null);

  const showDraggedElement = (newDraggedElement: ReactElement | null) => {
    setDraggedElement(newDraggedElement);
  };

  const hideDraggedElement = () => {
    setDraggedElement(null);
  };

  const contextValue = useMemo<DragOverlayContextType>(
    () => ({ draggedElement, showDraggedElement, hideDraggedElement }),
    [draggedElement]
  );

  return (
    <DragOverlayContext.Provider value={contextValue}>
      {children}
      <DragOverlayConsumer />
    </DragOverlayContext.Provider>
  );
};

export default DragOverlayProvider;
